import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store';
import VueStatic from 'vue-static';
import VueLocalStorage from 'vue-localstorage';
import axios from 'axios';
import auth from '@/services/security';
import { initAxios } from '@/store/api'
import VueKonva from 'vue-konva';


Vue.use(VueLocalStorage);
Vue.use(VueStatic);
Vue.use(VueKonva);
Vue.use(auth);

Vue.config.productionTip = false;

Vue.prototype.$http = axios;

new Vue({
  localStorage: {
    Global_customSelectionProjects: {
      type: Array,
      default: []
    },
    MANA_customSelectionProjects: {
      type: Array,
      default: []
    },
    isMANAVersion: {
      type: Boolean,
      default: false
    },
    listProduct: {
      type: Array,
      default: []
    },
    productFamilies: {
      type: Array,
      default: []
    },
    familyProducts: {
      type: Array,
      default: []
    },
    assets: {
      type: Array,
      default: []
    },
    allAssets: {
      type: Array,
      default: []
    },
    assetsMwc: {
      type: Object,
      default: {}
    },
    product: {
      type: Object,
      default: {}
    },
    allFamilyPreview: {
      type: Array,
      default: []
    }
  },
  router,
  store,
  created () {
    initAxios()
  },
  render: h => h(App)
}).$mount('#app');
